import { AuiIf } from '@assistant-ui/react';
import { FC } from 'react';
import { Suggestions } from './Suggestions';
import { type WelcomeConfig } from './WelcomeConfig';
import './WelcomeContent.scss';

export const WelcomeContent: FC<WelcomeConfig> = ({ avatar, propertyName, suggestions }) => (
  <AuiIf condition={(s) => s.thread.isEmpty}>
    <div className={'chat-welcome has-text-centered'}>
      <figure className={'image is-128x128 block'}>
        <img src={avatar.uri} alt={avatar.altText} />
      </figure>
      <p className={'block'}>Welcome to {propertyName}! How can I help you today?</p>
    </div>
    <Suggestions suggestions={suggestions} />
  </AuiIf>
);
WelcomeContent.displayName = 'WelcomeContent';
